import { render, staticRenderFns } from "./WorkProfile.vue?vue&type=template&id=565f0572"
import script from "./WorkProfile.vue?vue&type=script&lang=js"
export * from "./WorkProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports